/**
 * Runtime API endpoints.
 *
 * Defaults to localhost for dev. Set VITE_* env vars for production builds.
 */

/**
 * Auth API base URL
 */
// @ts-ignore
export const AUTH_API_URL: string =
  // @ts-ignore
  import.meta.env.VITE_AUTH_API_URL ??
  // @ts-ignore
  import.meta.env.VITE_API_URL ??
  'http://localhost:3001';

/**
 * Storage API base URL
 */
// @ts-ignore
export const STORAGE_API_URL: string =
  // @ts-ignore
  import.meta.env.VITE_STORAGE_API_URL ??
  'http://localhost:3003';

/**
 * Public storage API base URL
 */
// @ts-ignore
export const PUBLIC_API_URL: string =
  // @ts-ignore
  import.meta.env.VITE_PUBLIC_API_URL ??
  'http://localhost:3002';


